import { computed } from "vue";
import { u as useI18n } from "./index-CgZzOVq6.js";
const { t } = useI18n();
function useValidationsProp() {
  const MESSAGES = computed(() => ({
    requiredIf: t("ds.validations.errors.required"),
    required: t("ds.validations.errors.required"),
    phone: t("ds.validations.errors.phone"),
    email: t("ds.validations.errors.email"),
    cnpj: t("ds.validations.errors.cnpj"),
    cpf: t("ds.validations.errors.cpf"),
    date: t("ds.validations.errors.date"),
    fullName: t("ds.validations.errors.fullName"),
    dateInThePast: t("ds.validations.errors.dateInThePast")
  }));
  function createValidationsProp() {
    return {
      validations: {
        type: Object,
        default: () => ({})
      }
    };
  }
  function setupValidations(validations = {}) {
    const computedValidation = computed(() => (validations == null ? void 0 : validations.value) || validations);
    const hasNoValidation = computed(
      () => !computedValidation.value || !Object.keys(computedValidation.value).length
    );
    const validationError = computed(() => {
      const error = "";
      if (hasNoValidation.value) return error;
      const filteredValidations = Object.keys(computedValidation.value).filter(
        (key) => Object.keys(MESSAGES.value).includes(key)
      );
      if (!computedValidation.value.$dirty) return error;
      const validation = filteredValidations.find((val) => !computedValidation.value[val]);
      return MESSAGES.value[validation];
    });
    const triggerValidation = () => {
      if (hasNoValidation.value) return;
      if (computedValidation.value.$dirty || computedValidation.value.$model)
        computedValidation.value.$touch();
    };
    return {
      validationError,
      triggerValidation
    };
  }
  return {
    MESSAGES,
    createValidationsProp,
    setupValidations
  };
}
export {
  useValidationsProp as u
};
